<template>
  <div class="FaqMenu">
    <ul class="FaqMenu__list">
      <li class="FaqMenu__item" v-for="item in response" :key="item.id">
        <span
          class="FaqMenu__title FaqMenu__title--active"
          v-if="item.isActive"
        >
          {{ item.title }}
        </span>
        <button
          v-else
          class="FaqMenu__title"
          @click="setActiveItemMenu(item.id)"
        >
          {{ item.title }}
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'FaqMenu',
  props: {
    response: {
      type: Array,
      require: true,
    },
  },
  methods: {
    /**
     * Установка пункта меню активным
     * @param {Number} id - id пункта меню
     */
    setActiveItemMenu(id) {
      this.$emit('change', id);
    },
  },
};
</script>

<style lang="scss" scoped>
.FaqMenu {
  position: sticky;
  top: 24px;
  padding: 20px;
  background-color: $color-white;
  border-radius: 2px;
  box-shadow: $box-shadow-card-1;

  &__list {
    @include list-reset;

    display: flex;
    flex-direction: column;
  }

  &__item {
    margin-bottom: 15px;

    &:last-of-type {
      margin-bottom: 0;
    }
  }

  &__title {
    @include button-reset;

    display: block;
    font-size: rem(13);
    font-weight: 300;
    line-height: 17px;
    text-align: left;

    &--active {
      font-weight: normal;
      cursor: default;
    }
  }
}
</style>
